import React from 'react';
import PropTypes from 'prop-types';
import FluidTextBlocksContainer from '../FluidTextBlocksContainer/FluidTextBlocksContainer';
import FluidTextBlock from '../FluidTextBlock/FluidTextBlock';

const FluidTextBlocks2 = ({ config }) => {
  const { block1, block2 } = config;

  return (
    <FluidTextBlocksContainer>
      <FluidTextBlock {...block1} />
      <FluidTextBlock {...block2} />
    </FluidTextBlocksContainer>
  );
};

FluidTextBlocks2.propTypes = {
  config: PropTypes.shape({
    block1: PropTypes.node,
    block2: PropTypes.node,
  })
}

export default FluidTextBlocks2;
